import { createSelector } from '@reduxjs/toolkit';

import surveyModuleSelectors from './surveyModuleSelectors';

const rootSurveySelector = createSelector(
  surveyModuleSelectors.surveyDataSelector,
  surveyModuleSelectors.activeStepSelector,
  surveyModuleSelectors.isSurveySubmittedSelector,
  (surveyData, activeStep, isSurveySubmitted) => ({
    surveyData,
    activeStep,
    isSurveySubmitted,
  }),
);

export default rootSurveySelector;
